export type SameSite = 'Lax' | 'None' | 'Strict';

export enum CookieType {
  ANALYTICS = 'ANALÍTICA',
  TECNOLOGICAL = 'TECNOLÓGICAS'
}

export enum CookieProvider {
  SELF = 'Propia',
  THIRD = 'Terceros',
  GOOGLE = 'Google'
}

export enum CookieExpiration {
  SESSION = 'Session',
  DAY = '1 día',
  WEEK = '1 semana',
  MONTH = '1 mes',
  YEAR = '1 año'
}

export interface CookieOptions {
  expires?: number | Date;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: SameSite;
}

export class Cookie {
  // BASE PROPERTIES
  name: string;
  provider: CookieProvider;
  expiration: CookieExpiration;
  purpose: string;
  type: CookieType;

  // EXTENDED PROPERTIES
  value?: string;
  checked?: boolean;
  options?: CookieOptions;

  constructor(
    name: string,
    provider: CookieProvider,
    expiration: CookieExpiration,
    purpose: string,
    type: CookieType,
    value?: string,
    checked?: boolean,
    options?: CookieOptions
  ) {
    this.name = name;
    this.provider = provider;
    this.expiration = expiration;
    this.purpose = purpose;
    this.type = type;
    this.value = value ? value : '1';
    this.checked = checked ? checked : true;
    this.options = options ? options : this.getCookiesOptions(expiration);
  }

  private getCookiesOptions(expiration: CookieExpiration) {
    const expirationDate = new Date();
    switch (expiration) {
      case CookieExpiration.DAY:
        expirationDate.setDate(expirationDate.getDate() + 1);
        break;
      case CookieExpiration.WEEK:
        expirationDate.setDate(expirationDate.getDate() + 7);
        break;
      case CookieExpiration.MONTH:
        expirationDate.setMonth(expirationDate.getMonth() + 1);
        break;
      case CookieExpiration.YEAR:
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        break;
      case CookieExpiration.SESSION:
        expirationDate.setHours(23, 59);
        break;
      default:
        break;
    }

    const co: CookieOptions = {
      expires: expirationDate
    };

    return co;
  }
}

export interface CookieFiltered {
  type: CookieType,
  cookies: Cookie[]
}